'use client'

import Image from 'next/image'
import { createT } from '@/locales/index'
import { WithT } from '@/locales/types'
import { ArticleReactionType } from '@/api/types/article'
import { useRouter } from 'next/navigation'
import { ArticleApi } from '@/api/article'
import { useAuthStore } from '@/store/auth'
import classNames from 'classnames'
import { GenericLink } from '../GenericLink'

export interface Reaction {
  text: string
  image: string
  count: number
  key: ArticleReactionType
  isActive: boolean
}

interface ArticleReaction {
  articleId: number
  items: Reaction[]
}

export function ArticleReaction({
  articleId,
  items,
  translations,
}: WithT<ArticleReaction>) {
  const t = createT(translations)
  const router = useRouter()
  const authUser = useAuthStore()

  const handleReactionClick = async (key: ArticleReactionType) => {
    const params = {
      type: key,
    }

    await ArticleApi(authUser.accessToken).reaction(articleId, params)
    router.refresh()
  }

  return (
    <div className="flex flex-col py-4 gap-4 justify-center items-center">
      <h2 className="text-subtitle2 font-bold">
        {t('article.reaction.title')}
      </h2>

      <div className="flex gap-3">
        {items.map((item, idx) => (
          <div key={idx} className="flex flex-col gap-1 w-[65px] items-center">
            <GenericLink
              className="flex flex-col gap-1 items-center group"
              onClick={() => handleReactionClick(item.key)}
              privilege
            >
              <Image
                src={item.image}
                alt="리액션 이미지"
                width={32}
                height={32}
              />
              <span
                className={classNames(
                  'text-body1 font-medium text-gray-600 group-hover:text-key cursor-pointer',
                  item.isActive && 'text-key',
                )}
              >
                {item.text}
              </span>
            </GenericLink>

            <span
              className={classNames(
                'text-subtitle2 font-bold text-gray-900',
                item.isActive && 'text-key',
              )}
            >
              {item.count}
            </span>
          </div>
        ))}
      </div>
    </div>
  )
}
